import { atomWithStorage, createJSONStorage } from 'jotai/utils'

const persistentStorage = createJSONStorage<string | undefined>(() => localStorage)

export const authTokenAtom = atomWithStorage<string | undefined>(
    '@taxoparkee/token',
    undefined,
    persistentStorage,
    {
        getOnInit: true,
    }
)
